@if (wrapper.isReady && showLabel()) {
  <label class="form-label" [class]="getClass()" [for]="name">
    {{ getTranslationCode()| translate }}
    @if (isRequiredField()) {
      <span>{{ 'form.required.sign'|translate }}</span>
    }
    <!-- Info -->
    @if (hasInfo(name)) {
      <acc-icon name="info" styling="success" [ngbTooltip]="infoTooltipTpl"/>
    }
    <ng-template #infoTooltipTpl>
      @if (isInfoTranslated(name)) {
        <div [innerHTML]="getInfo(name)"></div>
      } @else {
        <div [innerHTML]="getInfo(name)|translate"></div>
      }
    </ng-template>
    <!-- Help -->
    @if (hasHelp(name)) {
      <acc-icon name="help" styling="help" [ngbTooltip]="helpTooltipTpl"/>
    }
    <ng-template #helpTooltipTpl>
      <span [innerHTML]="getHelp(name)|translate"></span>
    </ng-template>
    <!-- Warn -->
    @if (hasWarn(name)) {
      <acc-icon name="warn" styling="warning" [ngbTooltip]="getWarn(name)|translate"/>
    }
    <!-- Further attached elements, can be e.g. copy-clipboard -->
    <ng-content/>
  </label>
}
